"use client";
import React from "react";
import Icon from "components/common/Icon";
import Show from "components/common/Show";
import { colors } from "gstyles";
import cx from "classnames";
import { useRouter } from "next/navigation";
export default function Default({
  title,
  layout = "default",
  hasIcon = false,
  leftComponent = null,
  rightComponent = null,
  borderRadius = false,
}: {
  title: string;
  layout?: "default" | "primary";
  hasIcon?: boolean;
  leftComponent?: React.ReactNode;
  rightComponent?: React.ReactNode;
  borderRadius?: boolean;
}) {
  const router = useRouter();
  return (
    <div
      className={cx(
        "relative w-full bg-primary rounded-b-2xl",
        {
          "bg-white border-b border-gray-200 rounded-none": layout !== "primary",
        }
      )}
    >
      <div className={cx(
        "py-3 w-full flex items-center absolute top-0 left-0 right-0 bottom-0 z-10",
        hasIcon ? "justify-between" : "justify-center"
      )}>
        <Show.When isTrue={hasIcon}>
          <div className="w-[1.875rem] h-[1.875rem] flex justify-end items-center pl-4">
            <Show>
              <Show.When isTrue={leftComponent}>{leftComponent}</Show.When>
              <Show.Else>
                <Icon
                  onClick={() => router.back()}
                  className="rotate-180"
                  name="arrow-right"
                  size={20}
                  color={colors.white}
                />
              </Show.Else>
            </Show>
          </div>
        </Show.When>
        <span className={cx(
          "font-semibold text-white",
          layout !== "primary" && "text-black-01",
          layout === "primary" ? "text-base" : "text-lg"
        )}>{title}</span>
        <Show.When isTrue={hasIcon}>
          <div className="w-[1.875rem] h-[1.875rem] flex justify-end items-center pr-4">
            <Show.When isTrue={rightComponent}>{rightComponent}</Show.When>
          </div>
        </Show.When>
      </div>
      <div className="h-[3.25rem]"></div>
    </div>
  );
}
